/* Form.js */
import React, { useState } from "react";
import { useForm, ValidationError } from '@formspree/react';
import "./styles/Form.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", message: "" });
  const [formErrors, setFormErrors] = useState({});
  const [state, handleSubmit] = useForm("xannyddb");

  const validateForm = () => {
    const errors = {};
    if (!formData.name) errors.name = "Name is required";
    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) errors.email = "Valid email is required";
    if (!formData.phone || !/^\d{10}$/.test(formData.phone)) errors.phone = "10-digit phone number required";
    if (!formData.message) errors.message = "Message is required";
    return errors;
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm();
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) handleSubmit(e);
  };

  if (state.succeeded) {
    return <div className="form-success"><h3>Thank You!</h3><p>Your message has been sent successfully. We will contact you shortly.</p></div>;
  }

  return (
    <div className="form-container">
      <form onSubmit={onSubmit} className="modern-form">
        <h2>Send us a Message</h2>
        
        <div className="form-group">
          <label>Full Name</label>
          <input type="text" name="name" value={formData.name} onChange={handleChange} className={formErrors.name ? "invalid" : ""} placeholder="John Doe" />
          {formErrors.name && <span className="error-text">{formErrors.name}</span>}
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Email Address</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} className={formErrors.email ? "invalid" : ""} placeholder="john@example.com" />
            {formErrors.email && <span className="error-text">{formErrors.email}</span>}
          </div>
          <div className="form-group">
            <label>Phone Number</label>
            <input type="text" name="phone" value={formData.phone} onChange={handleChange} className={formErrors.phone ? "invalid" : ""} placeholder="072 123 4567" />
            {formErrors.phone && <span className="error-text">{formErrors.phone}</span>}
          </div>
        </div>

        <div className="form-group">
          <label>How can we help?</label>
          <textarea name="message" value={formData.message} onChange={handleChange} className={formErrors.message ? "invalid" : ""} placeholder="Tell us about your visa needs..."></textarea>
          {formErrors.message && <span className="error-text">{formErrors.message}</span>}
        </div>

        <button type="submit" className="submit-btn" disabled={state.submitting}>
          {state.submitting ? "Sending..." : "Submit Inquiry"}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
